import { Button, Tabs } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import IconLabel from '@fmbt/ui/IconLabel';
import { AntSwap, FiChevronLeft, FiRotateCcw } from '@fmbt/ui/icons';
import PageHeaderPusher from 'components/atoms/PageHeaderPusher';
import { RestoreTabContent, TransferTabContent } from 'components/features/backOffice/BackOfficeOperationsDataTransfer';

function BackOfficeOperationsDataTransfer(): JSX.Element {
  const navigate = useNavigate();

  const tabItems = [
    {
      key: 'transfer',
      label: (
        <IconLabel
          icon={<AntSwap style={{ margin: 0 }} />} // overrides `.ant-tabs-tab .anticon { margin-right: 12px }`
          label="Transfer"
          gap={12}
        />
      ),
      children: <TransferTabContent />
    },
    {
      key: 'restore',
      label: (
        <IconLabel
          icon={<FiRotateCcw />}
          label="History"
          gap={12}
        />
      ),
      children: <RestoreTabContent />
    }
  ];

  return (
    <PageHeaderPusher>
      <>
        <Button
          type="link"
          onClick={() => navigate('/back-office/operations')}
          style={{ padding: 0 }}
        >
          <IconLabel
            icon={<FiChevronLeft size={22} />}
            label="Back to operations"
            gap={4}
          />
        </Button>
        <Tabs items={tabItems} className="mt-16" />
      </>
    </PageHeaderPusher>
  );
}

export default BackOfficeOperationsDataTransfer;
